import React,{useEffect,useState} from 'react'
import ReactPlayer from 'react-player';
import {useParams,Link} from 'react-router-dom';
import {fetchDetails} from './getDetails';
import Video from './video';
import Comment from './Comments';
import {subscribeCount} from './getSubscriberCount';
import ChannelDetails from './ChannelDetails';

const VideoDetails = (props) => {
  const [VideoDetails,setVideoDetails] = useState([]);
  const [channelDetails,setChannelDetails] = useState([]);
  const [RecommendedVideos, setRecommendedVideos] = useState([]);
  const [Comments, setComments] = useState([]);
  const [tags,setTags] = useState([]);
  const [menu1,setMenu1] = useState('white');
  const [menu2,setMenu2] = useState('white');
  const [menu3,setMenu3] = useState('white');
  const [menu4,setMenu4] = useState('white');
  const [isSubscribed, setIsSubscribed] = useState(false);


  const handleClick1 = ()=>{
    menu1==='white'?setMenu1('#037ffc'):setMenu1('white');
  }
  const handleClick2 = ()=>{
    menu2==='white'?setMenu2('#037ffc'):setMenu2('white');
  }
  const handleClick3 = ()=>{
    menu3==='white'?setMenu3('#037ffc'):setMenu3('white');
  }
  const handleClick4 = ()=>{
    menu4==='white'?setMenu4('#037ffc'):setMenu4('white');
  }
  const {videoId} = useParams();
  console.log(videoId);
  // console.log(VideoDetails);

  
  useEffect(()=>{
    console.log("HI");
    const getVideoDetails = async()=>{
      const details1 = await fetchDetails(`videos?part=snippet,statistics&id=${videoId}`);
      const details2 = await fetchDetails(`search?part=id,snippet&type=video&relatedToVideoId=${videoId}`);
      // console.log(details1.items);
      // console.log(details2);
      // console.log(details.items[0]);
      setVideoDetails(details1.items[0]);
      setRecommendedVideos(details2.items.slice(0,20));
      // console.log(VideoDetails);
      props.HideToShow();
    }
   
    getVideoDetails();
  },[videoId]);

  useEffect(()=>{
    setChannelDetails([]);
    setVideoDetails([]);
    setRecommendedVideos([]);
    setComments([]);
    setTags([]);
    setMenu1('white');
    setMenu2('white');
    setMenu3('white');
    setMenu4('white');
    setIsSubscribed(false);
  },[videoId])

  useEffect(()=>{
    const getChannelDetails = async()=>{
      // console.log(VideoDetails);
      // console.log(VideoDetails?.snippet?.channelId);
      // const details = await fetchDetails(`search?part=snippet,id&channelId=${VideoDetails.snippet.channelId}`);
      const details = await fetchDetails(`channels?part=snippet,statistics&id=${VideoDetails.snippet.channelId}`);
      // setTimeout(async() => {
      // }, 2000);
      const comments = await fetchDetails(`commentThreads?part=snippet&maxResults=100&videoId=${videoId}`);
      // console.log(comments.items);
    setComments(comments.items);
      
      // console.log(details);
      setTags(VideoDetails?.snippet?.tags.length > 3 ? VideoDetails?.snippet?.tags.splice(0,3) :  VideoDetails?.snippet?.tags);
      // setTags(VideoDetails?.snippet?.tags.splice(0,3));
      console.log(VideoDetails?.snippet?.tags)
      setChannelDetails(details.items[0]);
      // setChannelDetails(details.items[0]);
      // console.log(details);
    }
    getChannelDetails();

  },[VideoDetails]);

  const viewCount = ()=>{
    if(VideoDetails.statistics?.viewCount<10000){
      return(`${VideoDetails.statistics?.viewCount.slice(0,1)}k`);
    }
    else if(VideoDetails.statistics?.viewCount>=10000 && VideoDetails.statistics?.viewCount<100000){
      return(`${VideoDetails.statistics?.viewCount.slice(0,2)}k`);
    }
    else if(VideoDetails.statistics?.viewCount>=100000 && VideoDetails.statistics?.viewCount<1000000){
      return(`${VideoDetails.statistics?.viewCount.slice(0,1)} lakh`);
    }
    else if(VideoDetails.statistics?.viewCount>=1000000 && VideoDetails.statistics?.viewCount<10000000){
      return(`${VideoDetails.statistics?.viewCount.slice(0,1)}M`);
    }
    else if(VideoDetails.statistics?.viewCount>=10000000 && VideoDetails.statistics?.viewCount<100000000){
      return(`${VideoDetails.statistics?.viewCount.slice(0,2)}M`);
    }
    else if(VideoDetails.statistics?.viewCount>=100000000 && VideoDetails.statistics?.viewCount<1000000000){
      return(`${VideoDetails.statistics?.viewCount.slice(0,3)}M`);
    }
  }

  
  // }

  // const getPublishedDate = ()=>{
  //   const date1 =VideoDetails?.snippet?.publishedAt.slice(0,10);
  //   // const date = new Date();
  //   const newDate = new Date(date1);
  //   console.log(newDate);
  //   return date1;
  // }
 
      // const tags = VideoDetails?.snippet?.tags.splice(0,3);
  
  
  return (
    <div className=' mt-14 m-2'>
      <div className="video w-full md:p-5 md:flex">
        <div className='md:w-[80%]'>

      <ReactPlayer url={`https://www.youtube.com/watch?v=${videoId}`}  className="flex justify-center items-center react-player" />

      <div className="flex space-y-4 my-2 ">
        <div className="details">
          <p className='tags text-[#248dff] text-sm  '>
            {tags?.map((tag,index)=>(
              <span key={index} className='mr-2'>#{tag}</span>
            ))}

          </p>
          <h1 className="text-xl text-white font-medium">{VideoDetails.snippet?.title}</h1>
          <div className='flex items-center text-[#9a9a9a]'>
            <span>{viewCount()} views</span>
            {/* <span>.</span> */}
            {/* <span> {getPublishedDate()}</span> */}
          </div>
          {/* <p className="text-sm text-[]">{VideoDetails.snippet?.description}</p> */}
          <div  className='flex flex-col space-y-6  md:flex-row md:gap-[7rem] '>
          <div className='flex space-x-16 ml-2 md:order-last md:w-[50%] items-center'>

          <div className="flex flex-col md:flex-row md:space-x-1 md:w-[3.9rem] w-10   items-center justify-center text-white"  onClick={handleClick1}>
              <svg className="w-10 md:w-20" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false" style={{pointerEvents: "none", fill:`${menu1}`}} ><g className="style-scope yt-icon"><path d="M18.77,11h-4.23l1.52-4.94C16.38,5.03,15.54,4,14.38,4c-0.58,0-1.14,0.24-1.52,0.65L7,11H3v10h4h1h9.43 c1.06,0,1.98-0.67,2.19-1.61l1.34-6C21.23,12.15,20.18,11,18.77,11z M7,20H4v-8h3V20z M19.98,13.17l-1.34,6 C18.54,19.65,18.03,20,17.43,20H8v-8.61l5.6-6.06C13.79,5.12,14.08,5,14.38,5c0.26,0,0.5,0.11,0.63,0.3 c0.07,0.1,0.15,0.26,0.09,0.47l-1.52,4.94L13.18,12h1.35h4.23c0.41,0,0.8,0.17,1.03,0.46C19.92,12.61,20.05,12.86,19.98,13.17z" className="style-scope yt-icon"></path></g></svg>
              <span>Like</span>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-1 md:w-[4.9rem] w-10   items-center justify-center text-white"  onClick={handleClick1}>
          <svg className="w-10 md:w-20" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false"  style={{pointerEvents: "none", fill:`${menu2}`}} ><g className="style-scope yt-icon"><path d="M17,4h-1H6.57C5.5,4,4.59,4.67,4.38,5.61l-1.34,6C2.77,12.85,3.82,14,5.23,14h4.23l-1.52,4.94C7.62,19.97,8.46,21,9.62,21 c0.58,0,1.14-0.24,1.52-0.65L17,14h4V4H17z M10.4,19.67C10.21,19.88,9.92,20,9.62,20c-0.26,0-0.5-0.11-0.63-0.3 c-0.07-0.1-0.15-0.26-0.09-0.47l1.52-4.94l0.4-1.29H9.46H5.23c-0.41,0-0.8-0.17-1.03-0.46c-0.12-0.15-0.25-0.4-0.18-0.72l1.34-6 C5.46,5.35,5.97,5,6.57,5H16v8.61L10.4,19.67z M20,13h-3V5h3V13z" className="style-scope yt-icon"></path></g></svg>
              <span>Dislike</span>
          </div>
          <div className="flex flex-col  md:flex-row md:space-x-1 md:w-[4.5rem] w-10   items-center justify-center text-white" onClick={handleClick3}>
              <svg className="w-10 md:w-20" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false"  style={{pointerEvents: "none", fill:`${menu3}`}} ><g mirror-in-rtl="" className="style-scope yt-icon"><path d="M15,5.63L20.66,12L15,18.37V15v-1h-1c-3.96,0-7.14,1-9.75,3.09c1.84-4.07,5.11-6.4,9.89-7.1L15,9.86V9V5.63 M14,3v6 C6.22,10.13,3.11,15.33,2,21c2.78-3.97,6.44-6,12-6v6l8-9L14,3L14,3z" className="style-scope yt-icon"></path></g></svg>
              <span>Share</span>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-1 md:w-[6.5rem] w-10   items-center justify-center text-white" onClick={handleClick4}>
              <svg className="w-10 md:w-20" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false"  style={{pointerEvents: "none", fill:`${menu4}`}} ><g className="style-scope yt-icon"><path d="M17 18V19H6V18H17ZM16.5 11.4L15.8 10.7L12 14.4V4H11V14.4L7.2 10.6L6.5 11.3L11.5 16.3L16.5 11.4Z" className="style-scope yt-icon"></path></g></svg>
              
              <span>Download</span>
          </div>

          </div>
          {/* <hr className='m-0 p-0 h-[0.1px] bg-[#aaa]'/> */}
          <div className='channelDetails flex justify-between items-center md:order-first md:space-x-5 md:w-[50%] '>
            <div className='flex space-x-6'>
              <Link to={`/channel/${VideoDetails?.snippet?.channelId}`}>
              <img className="w-[50px] h-[50px] rounded-full " src={channelDetails?.snippet?.thumbnails?.medium?.url} alt=""/>
              </Link>
              <div className='info flex flex-col  justify-center'>
                  <Link to={`/channel/${VideoDetails?.snippet?.channelId}`}>
                      <p className="text-md font-medium text-white">{VideoDetails.snippet?.channelTitle}</p>
                    </Link>
                  <span className='text-sm text-[#aaa]'>{subscribeCount(channelDetails)} subscribers</span>
              </div>
              </div>
                <button className='uppercase text-red-600 tracking-normal font-bold text-lg py-2 ' onClick={()=>{setIsSubscribed(!isSubscribed)}}>{isSubscribed? <span className='text-[#aaa]'>Subscribed</span> : <span className='text-red-600'>Subscribe</span>}</button>
              </div>
              
            </div>

          <div className="recommendation w-full md:hidden">
            <Video videos={RecommendedVideos} className=""/>
          </div>
          <div className="comments">
            <p className='text-white text-lg leading-3 tracking-wide my-5 font-bold'>Comments</p>
            <div className="space-y-5">
              {Comments.map((comment)=>{
                  return(
                    <Comment comment={comment}/>
                    )
                  })}
            </div>
          </div>
          </div>
      </div>
      </div>


        <div className="recommendation hidden md:block md:w-[20%]">
        <Video videos={RecommendedVideos} className=""/>
        </div>
      </div>
    </div>
  )
}

export default VideoDetails;
